export const NAME = 'create-proposal-modal';
